<template lang="pug">
    el-button.ButtonNext(@click="nextStepSCORM2" :disabled="disabled") Salto
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'ButtonNext',  
  methods: {    
    ...mapActions(['nextStepSCORM2'])
  },
  props: {        
    disabled: {
      type: Boolean,
      default: false
    }    
  },
}
</script>

<style scoped>
@import 'button-next.scss';
</style>

